import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import I18n from "i18n-js";
import useLocationForm, { UseLocationFormProps } from "./useLocationForm";
export interface LocationFormProps extends UseLocationFormProps {}

export default function LocationForm({
  id,
  afterSave,
  onClose,
  listItem,
}: LocationFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useLocationForm({
    id,
    afterSave,
  });
  console.log({ item });

  const title = isCreate
    ? I18n.t("Location.addTitle")
    : I18n.t("Location.editTitle");
  return (
    <>
      <PageHeader title={title} onClose={onClose} />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="Location.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="name" />
            </Field>
            <Field fullWidth>
              <TextField id="county" />
            </Field>
            <Field fullWidth>
              <TextField id="address" />
            </Field>
            <Field fullWidth>
              <TextField id="address2" />
            </Field>
            <Field fullWidth>
              <TextField id="zip" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
